import React, { createContext, useCallback, useContext, useState } from "react";

const TourContext = createContext({
  currentTour: null,
  startTour: () => {},
  endTour: () => {},
});

export const TourProvider = ({ children }) => {
  const [currentTour, setCurrentTour] = useState(null);
  // runId increments on every startTour() call. We pass it as `key` on
  // Joyride so each invocation gets a brand-new component instance with
  // fresh internal state — otherwise v3's internal store can hold onto
  // a previous "FINISHED" status and refuse to re-trigger.
  const [runId, setRunId] = useState(0);

  const startTour = useCallback((name) => {
    setRunId((n) => n + 1);
    // Force null first so even repeated calls to the same tour name fire
    // the consumer useEffect.
    setCurrentTour(null);
    setTimeout(() => setCurrentTour(name), 0);
  }, []);
  const endTour = useCallback(() => setCurrentTour(null), []);

  return (
    <TourContext.Provider value={{ currentTour, startTour, endTour, runId }}>
      {children}
    </TourContext.Provider>
  );
};

export const useTour = () => useContext(TourContext);

export default TourContext;
